import { Action, ThunkDispatch } from "@reduxjs/toolkit"
import { PatchCollection } from "@reduxjs/toolkit/dist/query/core/buildThunks"
import { NotificationInternalPayload } from "../../models/notification"
import { saveNotificationError, saveNotificationFakeError } from "../../store/notifications/thunks"
import { apiCallExceptionToSystemError } from "../../utility/common/apiCallExceptionToSystemError"
import { Dispatch } from "../../utility/common/storeHelper"

export const handleQueryApiError = (
    dispatch: Dispatch,
    errorMessage: string,
    e: unknown,
    patchResults?: (PatchCollection | undefined)[]
) => {
    const error = apiCallExceptionToSystemError(errorMessage, e)
    saveNotificationError(dispatch, error)

    if (patchResults) {
        for (const patchResult of patchResults) {
            if (patchResult) patchResult.undo()
        }
    }
}

export const handleQueryApiFakeError = (
    dispatch: Dispatch,
    message: NotificationInternalPayload,
    patchResults?: (PatchCollection | undefined)[]
) => {
    saveNotificationFakeError(dispatch, message)

    if (patchResults) {
        for (const patchResult of patchResults) {
            if (patchResult) patchResult.undo()
        }
    }
}

type OnQueryStartedContext<TResult> = {
    dispatch: ThunkDispatch<unknown, unknown, Action<unknown>>
    queryFulfilled: Promise<{ data: TResult; meta: unknown }>
}

export const onQueryStartedErrorHandler =
    <TArg, TResult>(errorMessage: string) =>
    async (
        args: TArg & { callback?: (response: TResult) => void },
        { dispatch, queryFulfilled }: OnQueryStartedContext<TResult>
    ) => {
        try {
            const response = await queryFulfilled
            if (args.callback) {
                args.callback(response.data)
            }
        } catch (error) {
            handleQueryApiError(dispatch, errorMessage, error)
        }
    }
